function personalizationAddon(item) {
  return item?.addons?.find(addon => addon.type === 'personalization');
}

// `??` not `||`: a free personalization is 0, which `||` would skip - and on the admin
// sidebar shape `customization` holds the tag order info object, not the amount.
function personalizationChargedPrice(item) {
  return item?.customizationAmount ?? item?.customization ?? 0;
}

// OrderItemAddonService supplies retailPrice for every personalizable product type. The
// charged amount is the fallback so a missing addon can never render NaN.
export function personalizationRetailPrice(item) {
  return personalizationAddon(item)?.retailPrice ?? personalizationChargedPrice(item);
}

export function personalizationEffectivePrice(item) {
  const addon = personalizationAddon(item);

  return addon?.isDiscounted ? addon.discountPrice ?? 0 : personalizationChargedPrice(item);
}

export function isPersonalizationDiscounted(item) {
  return !!personalizationAddon(item)?.isDiscounted;
}
